import {
  AudienceBuilderNodeTypes,
  NeighborOperators,
} from '@gl/lit/types/builders/audience_builder/index.js';

/**
 * Creates an edge id given a source, target, and type.
 */
export function createEdgeId(
  source: string,
  target: string,
  type: string
): string {
  return `${source}:${type}:${target}`;
}

export function defaultOperatorForType(
  type: AudienceBuilderNodeTypes
): NeighborOperators | undefined {
  switch (type) {
    case AudienceBuilderNodeTypes.FLEX:
    case AudienceBuilderNodeTypes.STEM:
    case AudienceBuilderNodeTypes.FILTER:
      return NeighborOperators.AND;
    case AudienceBuilderNodeTypes.AUDIENCE:
      return NeighborOperators.AND_NOT;
  }
}

/**
 * If an iverse of the provided operator exists, return it.
 *
 * @param operator - the operator you want the inverse of.
 */
export function getInverseOperator(operator: NeighborOperators) {
  switch (operator) {
    case NeighborOperators.AND:
      return NeighborOperators.AND_NOT;
    case NeighborOperators.AND_NOT:
      return NeighborOperators.AND;
    default:
      return null;
  }
}
